class GzStickyATC extends HTMLElement {
  constructor() {
    super();

    // Create a new Intersection Observer
    this.intersectionObserver = new IntersectionObserver(entries => {
      // Check if the target element is intersecting with the viewport
      const isVisible = entries[0].isIntersecting;
      if (!isVisible) {
        this.setStickyVisibility(this.isStickyVisible); // Show or hide sticky based on current state
      } else {
        this.setStickyVisibility(false); // Hide sticky if target element is in view
      }
    });

    // Reference to the target element
    this.targetElement = document.querySelector('.gz-product .product__info-container .product-form__submit');

    // Scroll position tracking
    this.lastScrollTop = 0;
    this.scrollThreshold = 10;
    this.isStickyVisible = false;

    // Throttle scroll event handler
    this.throttledScrollHandler = this.throttle(this.onScroll.bind(this), 200);

    // Initial check on component creation
    this.checkVisibility();

    // Attach scroll event listener
    window.addEventListener('scroll', this.throttledScrollHandler);
  }

  // Throttle function to limit the execution of the scroll handler
  throttle(func, limit) {
    let lastFunc;
    let lastRan;
    return function() {
      const context = this;
      const args = arguments;
      if (!lastRan) {
        func.apply(context, args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(function() {
          if (Date.now() - lastRan >= limit) {
            func.apply(context, args);
            lastRan = Date.now();
          }
        }, limit - (Date.now() - lastRan));
      }
    };
  }

  // Handle scroll events
  onScroll() {
    this.handleScrollVisibility();
  }

  // Handle visibility based on scroll direction and position
  handleScrollVisibility() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.lastScrollTop) {
      // Scrolling down
      if (scrollTop - this.lastScrollTop > this.scrollThreshold) {
        this.setStickyVisibility(true); // Hide sticky
      }
    } else {
      // Scrolling up
      if (this.lastScrollTop - scrollTop > this.scrollThreshold) {
        this.setStickyVisibility(false); // Show sticky
      }
    }

    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
  }

  // Set the visibility of the sticky element
  setStickyVisibility(visible) {
    if (visible && !this.isElementInViewport(this.targetElement)) {
      this.classList.add('active');
      this.isStickyVisible = true;
    } else {
      this.classList.remove('active');
      this.isStickyVisible = false;
    }
  }

  // Check visibility of the target element
  checkVisibility() {
    if (this.targetElement) {
      const isVisible = this.isElementInViewport(this.targetElement);
      if (!isVisible) {
        this.setStickyVisibility(this.isStickyVisible);
      }
    }
  }

  // Check if element is in viewport
  isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  // Clean up by disconnecting the observer and removing scroll event listener
  disconnectedCallback() {
    this.intersectionObserver.disconnect();
    window.removeEventListener('scroll', this.throttledScrollHandler);
  }
}

customElements.define('gz-sticky-atc', GzStickyATC);
